import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Multiselect from "multiselect-react-dropdown";
import {
  AddCardOutlined,
  AddCircle,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor

function Action(props) {
  const [isEdit, setisEdit] = useState(false);
  const dispatch = useDispatch();

  const [technicalServices, setTechnicalServices] = useState([
    {
      title: "Sampling",
      name: "sampling",
      check: false,
      disabled: true,
      detail: "",
    },
    {
      title: "Pull out Test",
      name: "pull_out_test",
      check: false,
      disabled: true,
      detail: "",
    },
    {
      title: "Supervision",
      name: "supervision",
      check: false,
      disabled: true,
      detail: "",
    },
    {
      title: "Complaint",
      name: "complaint",
      check: false,
      disabled: true,
      detail: "",
    },
    {
      title: "Training at Site",
      name: "training_at_site",
      check: false,
      disabled: true,
      detail: "",
    },
    {
      title: "Other Technical Support",
      name: "other_technical_support",
      check: false,
      disabled: true,
      detail: "",
    },
  ]);

  const [formData, setFormData] = useState({
    salePersonName: "",
    designation: "",
    location: "",
    state: "",
    siteDetail: "",
    products: [],
    visitDate: "",
  });

  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [productLoading, setProductLoading] = useState(false);
  const [productValid, setProductValid] = useState(false);
  const [isTechnicalServiceSelected, setIsTechnicalServiceSelected] =
    useState(false);

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }

    setFormData({
      ...formData,
      salePersonName: `${userProfile.firstName} ${userProfile.middleName} ${userProfile.lastName}`,
      designation: userProfile?.user_role[0].roleName,
    });
  }, [userProfile]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    if (name === "mobileNo") {
      validatedValue = value.replace(/\D/g, "");
    }

    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    const isTechnicalServiceValid = technicalServices.filter(
      (item) => item.check === true
    ).length;

    let error = 0;
    setProductValid(false);
    setIsTechnicalServiceSelected(false);
    if (formData.products.length === 0) {
      setProductValid(true);
      error++;
    }
    if (isTechnicalServiceValid === 0) {
      setIsTechnicalServiceSelected(true);
      error++;
    }

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      error++;
    }

    if (!error) {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      setIsSubmit(false);
      var bodyFormData = new FormData();
      if (isEdit) {
        bodyFormData.append("id", props?.rowData?.id);
      }
      bodyFormData.append("sales_person_name", formData.salePersonName);
      bodyFormData.append("designation", formData.designation);
      bodyFormData.append("location", formData.location);
      bodyFormData.append("state", formData.state);
      bodyFormData.append("site_details", formData.siteDetail);
      bodyFormData.append(
        "visit_date",
        moment(formData.visitDate).format("YYYY-MM-DD")
      );
      formData.products.forEach((product, index) => {
        bodyFormData.append(`products[${index}]`, product.id);
      });
      const filteredServices = technicalServices.filter(
        (service) => service.detail !== ""
      );

      filteredServices.forEach((service, index) => {
        bodyFormData.append(`technical_service_nm[${index}]`, service.name);
        bodyFormData.append(
          `technical_service_details[${index}]`,
          service.detail
        );
      });

      utils
        .callAPI("post", "/sales/save_request", bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setisEdit(true);
      setFormData({
        salePersonName: props?.rowData?.sales_person_name || "",
        siteDetail: props?.rowData?.site_details || "",
        designation: props?.rowData?.designation || "",
        state: props?.rowData?.state || "",
        location: props?.rowData?.location || "",
        visitDate: props?.rowData?.visit_date || "",

        products: props?.rowData?.products || [],
      });

      const apiData = props?.rowData?.technical_service || [];

      setTechnicalServices((prevServices) => {
        return prevServices.map((service) => {
          const matchingService = apiData.find(
            (apiItem) => apiItem.technical_service_nm === service.name
          );

          if (matchingService) {
            return {
              ...service,
              detail: matchingService.technical_service_details,
              check: true,
              disabled: false,
            };
          }
          return service;
        });
      });
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  const handleServiceChecked = (e, service) => {
    const updatedServices = technicalServices.map((technicalService, i) => {
      if (technicalService.name === service.name) {
        return {
          ...technicalService,
          check: !technicalService.check,
          disabled: !technicalService.disabled, // Toggle disabled state
          detail:
            !technicalService.disabled === true ? "" : technicalService.detail,
        };
      }
      return technicalService;
    });
    setTechnicalServices(updatedServices);
  };

  const handleServiceInputChange = (e, service) => {
    const serviceDetail = e.currentTarget.value || "";
    const updatedServices = technicalServices.map((technicalService, i) => {
      if (technicalService.name === service.name) {
        return {
          ...technicalService,
          detail: serviceDetail,
        };
      }
      return technicalService;
    });
    setTechnicalServices(updatedServices);
  };

  const handleProductSearch = (searchValue) => {
    setProductLoading(true);
    if (searchValue.trim() !== "") {
      utils
        .callAPI(
          "get",
          `/Product/product-autocomplete?name=${searchValue.trim()}`
        )
        .then((res) => {
          const products = [];
          if (typeof res !== "undefined") {
            res.map((item) => {
              products.push({ id: item?.id, name: item?.product_name });
            });
          }

          setProductOptions(products);
          setProductLoading(false);
        })
        .catch((err) => {
          setProductOptions([]);
          setProductLoading(false);
        });
    }
  };

  const handleProductSelect = (selectedLists) => {
    if (selectedLists.length > 0) {
      const name = "products";
      setFormData({
        ...formData,
        [name]: selectedLists,
      });
      setProductValid(false);
    } else {
      setProductValid(true);
    }
  };

  const handleManagerRemove = (selectedList, removedItem) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      products: prevFormData.products.filter(
        (product) => product.id !== removedItem.id
      ),
    }));
  };

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          <h4>
            {isEdit ? `Edit ` : `Request raised for Technical Service Support`}
          </h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Card>
              <RB.CardHeader>
                <h6 className={"mb-0"}>Sales Person Detail</h6>
              </RB.CardHeader>
              <RB.CardBody>
                <RB.Row>
                  <RB.Col md={6} className="mb-3">
                    <RB.FloatingLabel
                      label="Sales Person Name"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Name"
                        name="salePersonName"
                        value={formData.salePersonName}
                        onChange={handleInputChange}
                        required
                        maxLength={32}
                      />
                    </RB.FloatingLabel>
                  </RB.Col>
                  <RB.Col md={6} className="mb-3">
                    <RB.FloatingLabel
                      label="Designation"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Designation"
                        name="designation"
                        value={formData.designation}
                        onChange={handleInputChange}
                        required
                        maxLength={32}
                      />
                    </RB.FloatingLabel>
                  </RB.Col>
                </RB.Row>

                <RB.Row>
                  <RB.Col md={6} className="mb-3">
                    <RB.Row>
                      <RB.Col md={12} className="mb-3">
                        <RB.FloatingLabel
                          label="Location"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            type="text"
                            placeholder="Enter Location"
                            name="location"
                            value={formData.location}
                            onChange={handleInputChange}
                            required
                            maxLength={32}
                          />
                        </RB.FloatingLabel>
                      </RB.Col>
                      <RB.Col md={12} className="mb-3">
                        <RB.FloatingLabel
                          label="State"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            type="text"
                            placeholder="Enter State"
                            name="state"
                            value={formData.state}
                            onChange={handleInputChange}
                            required
                            maxLength={32}
                          />
                        </RB.FloatingLabel>
                      </RB.Col>
                    </RB.Row>
                  </RB.Col>
                  <RB.Col md={6} className="mb-3">
                    <RB.FloatingLabel
                      label="Site Details"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        as={"textarea"}
                        rows={4}
                        placeholder="Enter Site Details"
                        name="siteDetail"
                        value={formData.siteDetail}
                        onChange={handleInputChange}
                        required
                        style={{ height: "132px" }}
                      />
                    </RB.FloatingLabel>
                  </RB.Col>
                </RB.Row>
              </RB.CardBody>
            </RB.Card>
            <RB.Card>
              <RB.Card.Header
                className={"justify-content-between align-items-center"}
              >
                <h6 className={"mb-0"}>Request for technical service</h6>

                {isTechnicalServiceSelected && (
                  <div className="text-danger">
                    Please select at least one technical support.
                  </div>
                )}
              </RB.Card.Header>
              {/*<label className={"font-weight-600"}>Request for technical service</label>*/}
              <RB.Table
                className={"mb-0"}
                size={"sm"}
                responsive={true}
                bordered={true}
              >
                <thead>
                  <tr>
                    <th
                      valign={"middle"}
                      className={"text-center"}
                      style={{ width: "5%" }}
                    >
                      Sr.No.
                    </th>
                    <th style={{ width: "40%" }}>Service</th>
                    <th style={{ width: "10%" }}></th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {technicalServices.map((service, index) => (
                    <tr key={index}>
                      <td valign={"middle"} className={"text-center"}>
                        {index + 1}
                      </td>
                      <td valign={"middle"}>{service.title}</td>
                      <td valign={"middle"}>
                        <RB.Form.Check
                          type={"switch"}
                          name={"technicalService"}
                          value={service.name}
                          checked={service.check}
                          onChange={(e) => handleServiceChecked(e, service)}
                        />
                      </td>
                      <td valign={"middle"}>
                        <RB.FormGroup label="Site Details">
                          <RB.Form.Control
                            as={"textarea"}
                            placeholder="Enter Details"
                            name="serviceDetail"
                            value={service.detail}
                            onChange={(e) =>
                              handleServiceInputChange(e, service)
                            }
                            style={{ resize: "none" }}
                            disabled={service.disabled}
                            required
                          />
                        </RB.FormGroup>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </RB.Table>
            </RB.Card>

            <RB.Card>
              {/*<RB.CardHeader><h6 className={"mb-0"}>Products</h6> </RB.CardHeader>*/}
              <RB.CardBody>
                <RB.Row className={"mb-3 row-cols-2"}>
                  <RB.Col>
                    <h6>Products</h6>
                    <Multiselect
                      displayValue="name"
                      onKeyPressFn={function noRefCheck() {}}
                      onSearch={handleProductSearch}
                      onSelect={(selectedList) =>
                        handleProductSelect(selectedList)
                      }
                      name={formData.products}
                      loading={productLoading}
                      onRemove={handleManagerRemove}
                      // value={formData.channelName}
                      // onChange={handleInputChange}
                      // closeOnSelect={formData.channelName !== ""}
                      required
                      options={
                        Array.isArray(productOptions) ? productOptions : []
                      }
                      selectedValues={
                        formData.products && Array.isArray(formData.products)
                          ? formData.products
                          : []
                      }
                      placeholder="Select Products"
                      customCloseIcon={
                        <>
                          <i className="material-icons-outlined md14 ms-1">
                            cancel
                          </i>
                        </>
                      }
                      style={{
                        chips: {
                          background: "#FFDE1B",
                          color: "#000000",
                          borderRadius: "1rem",
                          cursor: "pointer",
                        },
                        multiselectContainer: {
                          zIndex: 10,
                        },
                        searchBox: {
                          border: "none",
                          borderBottom: "1px solid #dee2e6",
                          borderRadius: "0px",
                        },
                      }}
                      // placeholder="Select Channel Partner Name..."
                    />
                    {productValid && (
                      <div className="text-danger mt-1">
                        Please select at least one Product.
                      </div>
                    )}
                  </RB.Col>
                  <RB.Col>
                    <h6>Expected / Required visit date</h6>
                    <RB.FloatingLabel
                      label=""
                      className={`floating-label-fancy ${
                        formData.poDate ? "dateSelected" : "dateempty"
                      }`}
                    >
                      <DatePicker
                        selected={formData.visitDate}
                        onChange={(date) =>
                          setFormData({ ...formData, visitDate: date })
                        }
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        // placeholderText="Order Date"

                        //   maxDate={moment().toDate()}
                      />
                    </RB.FloatingLabel>
                  </RB.Col>
                </RB.Row>
              </RB.CardBody>
            </RB.Card>

            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Action;
